import { WorkBlockTripsDetails, WorkDaysOfBidLine } from "./Lines";
import { VacationStateLine } from "./VacationStateLine";
import { WorkBlockDetails } from "./WorkBlockDetails";

export class CalendarData {
  id: number;
  day: string;
  tripStartTime: string;
  tripEndTime: string;
  isEnabled: boolean;
  tripNum: string;
  startDay: string;
  tripColor: string;
  tripVacColor: boolean;
  tripFvColor: boolean;
  DateStr: string;
  leftRounded: boolean;
  rightRounded: boolean;
  weekName: string;
  vacLeftRounded: boolean;
  vacRightRounded: boolean;
  isEOMDate: boolean;
  isEOMStartDate: boolean;
  isEOMEndDate: boolean;
  hideInExpanded?: boolean;
  showTripBorder?:boolean
  myCalColor: boolean;
  overNightTime?:string;
}

export class LineCalendarData {
  constructor() {
    this.VacationStateLine = new VacationStateLine();
  }
  lineNumber: string;
  calendarObj: CalendarData[] = [];
  lineProperties: [];
  isFiltered: boolean;
  isBidList: boolean;
  lineIndex: number;
  isSelected?: boolean;
  isAboveInsert?: boolean;
  isBelowInsert?: boolean;
  faPositions?: any;
  flagColor?: string;
  flagColorArray?: FlagColor[];
  isTrashed?: boolean;
  trashOrder?: number;
  isFreezeLine?: boolean;
  faPositionColor?: any;
  isAwardedLine?: boolean;
  positionColor?: string;
  markerText?: string;
  isReserveLine?: boolean;
  isMRTLine?: boolean;
  etopsChar?: string;
  isHiddenBidList?: boolean;
  trashedLineArray?: TrashedPositions[];  
  LineNum: number;   //properties of lines for sorting of bidlist.
  VacationStateLine: VacationStateLine;
  AcftChanges: number;
  LegsIn700: number;
  LegsIn800: number;
  LegsIn600: number;
  LegsIn200: number;
  DaysOff: number;
  Legs: number;
  LargestBlkOfDaysOff: number;
  BlkHrsInBp: string;
  Trips1Day: number;
  Trips2Day: number;
  Trips3Day: number;
  Trips4Day: number;
  TotPairings: number;
  TotDutyPds: number;
  MaxLegsDay: number;
  NonConusCount: number;
  Tfp: number;
  TfpPerFltHr: number;
  TfpPerDay: number;
  TfpPerDhr: number;
  TfpPerLeg: number;
  TfpPerTafb: number;
  CarryOutPay: number;
  LineRig: number;
  DeadHead: number;
  Pairings: string[];
  SwaptimizerPulledTrips: string[];
  HighlightedFilterTrip: string[];
  OvernightInBase: number;
  PassThruBase: number;
  MidTripPTBs: number;
  MinOvernightLength: number;
  MaxOvernightLength: number;
  ETOPSTripsCount: number;
  VacPlusRig: number;
  TempTfp: number;
  FlyPay: number;
  VacPayNeBp: number;
  VacPayBothBp: number;
  TempTfpPerFltHr: number;
  TempTfpPerDay: number;
  TempBlkHrsInBp: string;
  TempDaysOff: number;
  EffectiveVacationLength: number;
  vLongest: number;
  VacationOverlapFront: number;
  VacationOverlapBack: number;
  AMPM: string;
  DaysOfWeekWork: number[];
  EDomPush: string;
  LastDomArrMinutes: number;
  TafbInLine: string;
  FlagColor: string;
  OvernightCitiesAll: string[];
  LegsThruCount: number;
  RegionalCityCount: number;
  ReserveType: string;
  CBReservePairing: string[];
  DutyHrsInLine: string;
  DeadheadCount: number;
  ETOPS: boolean;
  ReserveLine: boolean;
  DaysOfMonthWorks: WorkDaysOfBidLine[] = [];
  OverlapDays: number;
  commutableFronts: number;
  CommutableBacks: number;
  WorkBlockList: WorkBlockDetails[] = [];
  WorkBlockTrips: WorkBlockTripsDetails[] = [];
  HighlightedSortTrip: string[];
  CommutabilityFront: number;
  CommutabilityBack: number;
  CommutabilityOverall: number;
  TotalCommutes: number;
  BlankLine: boolean;
  NightsInMid: number;
  FlagOrder: number;
  DaysOfMonthOffCount: number;
  RedEye: boolean;
}

export class FlagColor {
  position: string;
  color: string;
}
export class TrashedPositions {
  position: string;
  order: number;
  isTrashed: boolean;
}
